import { Component, OnInit } from '@angular/core';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { FormGroup, FormControl, RequiredValidator, Validators, MaxLengthValidator } from '@angular/forms';
import { PortabilidadeService } from 'src/app/services/portabilidade.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NgxMaskDirective } from 'ngx-mask';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-portabilidade',
    templateUrl: './portabilidade.component.html',
    styleUrls: ['./portabilidade.component.css'],
    imports: [NgxMaskDirective, ReactiveFormsModule]
})
export class PortabilidadeComponent implements OnInit {

  loading: boolean = false;

  modalStep: string = "portab_1";
  urlChat: string = null;
  credenciais: any = null;

  form: FormGroup = null;
  formTudo: FormData = new FormData();

  arq1Nome: string = null;
  arq1Tamanho: number = null;

  constructor(private autenticacao: AutenticacaoService, private portabilidade: PortabilidadeService, private toastr: ToastrService) {
    this.credenciais = this.autenticacao.getCredenciais();
    this.modalStep = "portab_1";
  }

  ngOnInit() {

    this.modalStep = "portab_1";

    this.gerarUrlChat();

    this.form = new FormGroup({
      nomeArquivo: new FormControl(null),
      entidadeCedente: new FormControl(null, [Validators.required]),
      planoReceptor: new FormControl(null, [Validators.required]),
      numIdentificacaoPlano: new FormControl(null, [Validators.required]),
      cnpb: new FormControl(null, [Validators.required]),
      modalidadePlano: new FormControl(null, [Validators.required]),
      valor: new FormControl(null, [Validators.required]),
      regimeTributario: new FormControl(null, [Validators.required])      
    });
  }

  gerarUrlChat(){

    let c: any = this.credenciais;
    this.urlChat = `https://api.whatsapp.com/send/?phone=554133079222&text=Ol%C3%A1%2C+quero+solicitar+uma+portabilidade+para+o+Viva+Mais+Previd%C3%AAncia&type=phone_number&app_absent=0`;
  }

   //upload de arquivo
   handleFileInput(event: any): boolean {

    let file: File = event.target.files.item(0);
    let size = file.size / 1024;

    if (size > 10240) {
      event.target.value = "";
      alert("Erro: Tamanho máximo do arquivo 10MB");
      return false;
    }

    this.arq1Nome = file.name;
    this.arq1Tamanho = file.size;

    this.formTudo.set('arquivo', file, file.name);

    return true;
  }

  enviarSolicitacao(): boolean{

    let valor = this.form.get("valor").value;

    if(valor < 0){
      alert("O valor não pode ser negativo");
      this.form.get("valor").setValue("");
      return false;
    }else if(valor > 10000000.00){
      alert("O valor não pode ser maior que R$: 10.000.000,00");
      this.form.get("valor").setValue("");
      return false;
    }

    this.loading = true;

    for (const field in this.form.controls) {
      if(this.form.get(field).value!=null){
        this.formTudo.set(field, this.form.get(field).value); 
      }
    }
    

    this.formTudo.set('valor', valor.toFixed(2).toString().replace(".", ",")); 

    this.portabilidade
        .enviarEmail(this.formTudo)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: boolean) => {

            if(res){
                this.modalStep = "portab_3";
            }

          },
          (httpError: HttpErrorResponse) => {
            this.toastr.error("Falha ao enviar solicitação, por favor, tente novamente mais tarde");
          }
        )

    return true;
  }


}
